export default __webpack_public_path__ + "static/media/user_2.247fbed7.svg";